// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aea5a6ae","239":"b3cb07fd","355":"852494ed","453":"8d9f94b8","732":"b0e83338","938":"c00b635a"}[chunkId] + ".chunk.js";
};